import { getSourceImageByType } from './helpers';
import { CardTypeImageStyled } from './style';
import { CardTypeImageProps } from './types';

export const CardTypeImage: React.FC<CardTypeImageProps> = ({ assetLoader, className, enabled, type }) =>
    assetLoader?.isInitialized ? (
        <CardTypeImageStyled
            className={className}
            src={assetLoader.getAssetSrc(`creditCards/${getSourceImageByType(type)}`)}
            enabled={enabled}
        />
    ) : null;
